import React, { useState } from 'react'
import { Dialog } from '@ui'
import { NavigateFn } from '@reach/router'
import NeighborhoodForm from './NeighborhoodForm'
import { INeighborhoodDetails } from '@api'
import { useReload } from '@hooks/reloadContext'

export default function NewNeighborhoodDialog({
  floorId,
  navigate,
}: {
  floorId?: string
  navigate?: NavigateFn
}) {
  const [dirty, setDirty] = useState(false)

  const onClose = () => navigate && navigate(window.location.pathname)

  const reload = useReload()

  return (
    <Dialog
      isOpen
      style={{ width: 900, position: 'relative' }}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      transitionDuration={200}
      isCloseButtonShown={false}
      title="New Neighborhood"
      onClose={onClose}
      body={
        <NeighborhoodForm
          dirty={dirty}
          floorId={floorId}
          setDirty={setDirty}
          onSubmit={(newNeighborhood: INeighborhoodDetails) => {
            reload?.neighborhoods()
            navigate?.(`?neighborhoodId=${newNeighborhood.id}`)
          }}
          onCancel={onClose}
        />
      }
    />
  )
}
